import React from "react"; // eslint-disable-line no-unused-vars
import ReactDOM from "react-dom";
import App from "./components/app";
import { Provider } from "./store/provider";

if (process.env.NODE_ENV === "development") {
  console.log("TB-CATEGORY: Loading");
}

let render = function (app, theme) {
  let categoryID = app.getAttribute("data-categoryid");
  ReactDOM.render(
    <React.Fragment>
      <Provider>
        <App theme={theme} categoryID={categoryID} />
      </Provider>
    </React.Fragment>,
    app
  );
};

let loadApp = function () {
  if (process.env.NODE_ENV === "development") {
    console.log("TB-CATEGORY: Initializing React component");
  }
  let app = document.getElementById("tbcategory");
  if (app) {
    fetch(process.env.THEME_URL)
      .then((response) => response.json())
      .then((theme) => {
        render(app, theme);
      })
      .catch((error) => {
        if (process.env.NODE_ENV === "development") {
          console.log("TB-CATEGORY: ", error);
        }
        render(app, {});
      });
  } else {
    if (process.env.NODE_ENV === "development") {
      console.log("TB-CATEGORY: No element to insert component into");
    }
  }
};
if (document.readyState === "loading") {
  if (process.env.NODE_ENV === "development") {
    console.log("TB-CATEGORY: Waiting for document ready state");
  }
  document.addEventListener("DOMContentLoaded", loadApp);
} else {
  loadApp();
}
